import React, { useState, useRef, useEffect } from 'react';
import { Button, CircularProgress, Box, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { feathersCreateData } from '../services';
import Footer from '../components/Complements/Footer';
import { PersonAddAlt1Outlined } from '@mui/icons-material';
import { themeLogin } from '../styles/LoginTheme';

const SuggestionForm = (props) => {
  const { user, handleOpenSnack, openDialogBeneficiaryForm } = props;

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
    validateForm();
    // eslint-disable-next-line
  }, [description, title]);

  const validateForm = () => {
    if (title.trim() !== '' && description.trim() !== '') {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const suggestionData = {
        userId: user.id,
        title,
        description,
      };
      await feathersCreateData('suggestion', suggestionData)();
      handleOpenSnack('Sugerencia creada con éxito', 'success');
      setTitle('');
      setDescription('');
    } catch (error) {
      handleOpenSnack('Error al crear la sugerencia', 'error');
      console.log("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
<Box
  display="flex"
  flexDirection="column"
  justifyContent="center"
  alignItems="center"
  minHeight="80vh"
  style={{ marginTop: '20px' }}
>
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      maxWidth: 600, // Limita el ancho del Box
      padding: 3, // Reducimos el padding para que el contenido ocupe menos espacio
      boxShadow: 3,
      backgroundColor: 'transparent',
      borderRadius: 5,
      fontFamily: 'Roboto, sans-serif',
      flexGrow: 1, // Permite que el Box crezca si es necesario
    }}
  >
    <Typography
      variant="h4"
      sx={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: 3, // Reducimos el marginBottom para que no ocupe tanto espacio
        fontFamily: 'Roboto, sans-serif',
      }}
    >
      Sugerencias
      <EditIcon sx={{ marginLeft: '20px' }} />
    </Typography>
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: '20px', // Reducimos el marginTop para que no se aleje mucho del título
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ fontFamily: 'Roboto, sans-serif' }}>
        Título
      </Typography>
      <Box
        sx={{
          borderBottom: '2px solid #2E2657',
          marginBottom: 3,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{
            border: 'none',
            outline: 'none',
            width: '100%',
            padding: 0,
            fontSize: '1rem',
            color: '#2E2657',
            fontFamily: 'Roboto, sans-serif',
            backgroundColor: 'transparent',
          }}
        />
      </Box>
      <Typography variant="h6" gutterBottom sx={{ marginTop: 3, fontFamily: 'Roboto, sans-serif' }}>
        Descripción
      </Typography>
      <Box
        sx={{
          borderBottom: '2px solid #2E2657',
          marginBottom: 3,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <textarea
          ref={textareaRef}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={1}
          style={{
            border: 'none',
            outline: 'none',
            width: '100%',
            padding: '8px 0',
            fontSize: '1rem',
            color: '#2E2657',
            lineHeight: '1.5',
            resize: 'none',
            overflow: 'hidden',
            fontFamily: 'Roboto, sans-serif',
            backgroundColor: 'transparent',
          }}
        />
      </Box>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={loading || !isFormValid}
        sx={{
          marginTop: 2,
          backgroundColor: '#2E2657',
          '&:hover': {
            backgroundColor: '#2E2657',
          },
          fontFamily: 'Roboto, sans-serif',
          padding: '12px 24px',
          fontSize: '0.875rem',
          height: 'auto',
          minWidth: '250px',
          borderRadius: 10,
        }}
      >
        {loading ? <CircularProgress size={34} /> : 'Enviar Sugerencia'}
      </Button>
    </Box>
  </Box>

  {/* Footer debajo del contenido */}
  <Footer
    style={{
      height: '10vh', // Ajusta el tamaño del footer
      backgroundColor: themeLogin?.palette?.backlight?.main || '#cccccc',
      borderRadius: '5px',
      position: 'relative',
      bottom: 0, // Se coloca debajo del contenido
      width: '100%', // Ocupa todo el ancho de la pantalla
      padding: '10px 0', // Ajusta el padding si es necesario
    }}
  >
    <Button
      startIcon={<PersonAddAlt1Outlined />}
      color="primary"
      variant="outlined"
      onClick={() => openDialogBeneficiaryForm()}
    >
      <span style={{ color: '#000' }}>Nuevo contacto</span>
    </Button>
  </Footer>
</Box>

  );
};

export default SuggestionForm;
